var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19C6.86771 19 4.6263 18.0747 2.77578 16.2242C0.925261 14.3737 0 12.1323 0 9.5C0 6.86771 0.925261 4.6263 2.77578 2.77578C4.6263 0.925261 6.86771 0 9.5 0C11.1823 0 12.6568 0.341407 13.9234 1.02422C15.1901 1.70703 16.2885 2.64219 17.2188 3.82969V0H19V7.54063H11.4594V5.75938H16.4469C15.6948 4.57188 14.7349 3.61198 13.5672 2.87969C12.3995 2.1474 11.0437 1.78125 9.5 1.78125C7.34271 1.78125 5.51693 2.52839 4.02266 4.02266C2.52839 5.51693 1.78125 7.34271 1.78125 9.5C1.78125 11.6573 2.52839 13.4831 4.02266 14.9773C5.51693 16.4716 7.34271 17.2188 9.5 17.2188C11.1427 17.2188 12.6469 16.7487 14.0125 15.8086C15.3781 14.8685 16.3281 13.6266 16.8625 12.0828H18.7031C18.1292 14.1609 16.9911 15.8333 15.2891 17.1C13.587 18.3667 11.6573 19 9.5 19Z",
    fill: "#2C2D3E",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingFile);
export default __webpack_public_path__ + "static/media/loadingFile.bdd2bfec404c95859fc5b604cc8a4de0.svg";
export { ForwardRef as ReactComponent };